export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  const register = () => {
    const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);

    // A service worker can only control pages served from its own origin.
    if (publicUrl.origin !== window.location.origin) return;

    const publicPath = publicUrl.pathname.endsWith('/')
      ? publicUrl.pathname
      : `${publicUrl.pathname}/`;
    const serviceWorkerUrl = `${publicPath}service-worker.js`;

    navigator.serviceWorker.register(serviceWorkerUrl).catch((error) => {
      // Installation remains usable as a normal website if registration fails.
      console.error('GalaGo service worker registration failed:', error);
    });
  };

  if (document.readyState === 'complete') {
    register();
  } else {
    window.addEventListener('load', register, { once: true });
  }
}
